import { IRoutesDefined } from "@/api_framework/api_modals/Routers";

export const CONFIGURATION_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  CONFIGURATION_MODULE: {
    id: "CONFIGURATION_MODULE",
    title: "CONFIGURATION_MODULE",
    RBACDescription: "all in one ",
    RBACDisplayName: "CONFIGURATION_MODULE",
    icon: "BsCardChecklist",
    path: "config",
    url: "/app/configuration/config",
    isVirtual: true,
    children: {},
  },
  CLINIC_AND_CITY_SETUP: {
    id: "CLINIC_AND_CITY_SETUP",
    title: "CLINIC_AND_CITY_SETUP",
    RBACDescription: "clinic and city , warehouse , equipment setup ",
    RBACDisplayName: "CLINIC_AND_CITY_SETUP_PAGE",
    icon: "BsCardChecklist",
    path: "cta-action",
    url: "/app/configuration/cta-action",
    isVirtual: true,
    children: {},
  },
  STAFF_SETUP_PAGE: {
    id: "STAFF_SETUP_PAGE",
    title: "STAFF_SETUP_PAGE",
    RBACDescription: "Staff Role , staff onboard setup ",
    RBACDisplayName: "STAFF_SETUP_PAGE",
    icon: "BsCardChecklist",
    path: "cta-action-staff",
    url: "/app/configuration/cta-action-staff",
    isVirtual: true,
    children: {},
  },
  ROTA_SETUP_PAGE: {
    id: "ROTA_SETUP_PAGE",
    title: "ROTA_SETUP_PAGE",
    RBACDescription: "Staff Rota onboard , staff shift ",
    RBACDisplayName: "ROTA_SETUP_PAGE",
    icon: "BsCardChecklist",
    path: "cta-action-rota",
    url: "/app/configuration/cta-action-rota",
    isVirtual: true,
    children: {},
  },
  QUICK_COMM_PAGE: {
    id: "QUICK_COMM_PAGE",
    title: "QUICK_COMM_PAGE",
    RBACDescription: "PIN code add",
    RBACDisplayName: "QUICK_COMM_PAGE",
    icon: "BsCardChecklist",
    path: "cta-action-quick",
    url: "/app/configuration/cta-action-quick",
    isVirtual: true,
    children: {},
  },
  INVENTORY_MODULE_PAGE: {
    id: "INVENTORY_MODULE_PAGE",
    title: "INVENTORY_MODULE_PAGE",
    RBACDescription: "Inventory module",
    RBACDisplayName: "INVENTORY_MODULE_PAGE",
    icon: "BsCardChecklist",
    path: "cta-action-inventory",
    url: "/app/configuration/cta-action-inventory",
    isVirtual: true,
    children: {},
  },
  COUPON_MEMBERSHIP_PAGE: {
    id: "COUPON_MEMBERSHIP_PAGE",
    title: "COUPON_MEMBERSHIP_PAGE",
    RBACDescription: "COUPON and membership",
    RBACDisplayName: "COUPON_MEMBERSHIP_PAGE",
    icon: "BsCardChecklist",
    path: "cta-action-coupon-membership",
    url: "/app/configuration/cta-action-coupon-membership",
    isVirtual: true,
    children: {},
  },
  WHITE_LIST_MOBILE_PAGE: {
    id: "WHITE_LIST_MOBILE_PAGE",
    title: "WHITE_LIST_MOBILE_PAGE",
    RBACDescription: "image url",
    RBACDisplayName: "WHITE_LIST_MOBILE_PAGE",
    icon: "BsCardChecklist",
    path: "cta-action-white-list",
    url: "/app/configuration/cta-action-white-list",
    isVirtual: true,
    children: {},
  },
  CLINIC_LAB_REPORT_PAGE: {
    id: "CLINIC_LAB_REPORT_PAGE",
    title: "CLINIC_LAB_REPORT_PAGE",
    RBACDescription: "clinic lab report",
    RBACDisplayName: "CLINIC_LAB_REPORT_PAGE",
    icon: "BsCardChecklist",
    path: "cta-action-clinic-lab-report",
    url: "/app/configuration/cta-action-clinic-lab-report",
    isVirtual: true,
    children: {},
  },

  CLINIC_SETUP: {
    id: "CLINIC_SETUP",
    title: "clinic_setup",
    icon: "AiOutlineUser",
    url: "/app/configuration/clinic-setup",
    RBACDisplayName: "CLINIC_LIST",
    RBACDescription: "Access to setup clinics list.",
    path: "clinic-setup",
    children: {},
  },
  CLINIC_SETUP_ONBOARD: {
    id: "CLINIC_SETUP_ONBOARD",
    title: "clinic_setup_onboard",
    icon: "AiOutlineUser",
    RBACDisplayName: "SETUP_CLINIC",
    RBACDescription: "Access to setup clinic page and action.",
    url: "/app/configuration/clinic-onboard",
    path: "clinic-onboard",
    children: {},
  },
  CLINIC_SETUP_ONBOARD_EDIT: {
    id: "CLINIC_SETUP_ONBOARD_EDIT",
    title: "CLINIC_SETUP_ONBOARD_EDIT",
    icon: "AiOutlineUser",
    RBACDisplayName: "EDIT_CLINIC",
    RBACDescription: "Access to edit clinic page and action.",
    url: "/app/configuration/clinic-onboard",
    path: "clinic-onboard",
    isVirtual: true,
    children: {},
  },
  CLINIC_SETUP_IMAGE_UPDATE: {
    id: "CLINIC_SETUP_IMAGE_UPDATE",
    title: "clinic_setup_image_update",
    icon: "AiOutlineUser",
    RBACDisplayName: "EDIT_CLINIC_IMAGES",
    RBACDescription: "Access to edit clinic images page and action.",
    url: "/app/configuration/clinic-image-update",
    path: "clinic-image-update",
    isVirtual: true,
    children: {},
  },
  CITY_SETUP: {
    id: "CITY_SETUP",
    title: "city_setup",
    icon: "AiOutlineUser",
    url: "/app/configuration/city-setup",
    RBACDisplayName: "CITY_LIST",
    RBACDescription: "Access to city list page.",
    path: "city-setup",
    children: {},
  },
  CITY_SETUP_ONBOARD: {
    id: "CITY_SETUP_ONBOARD",
    title: "city_setup_onboard",
    icon: "",
    RBACDescription: "Access to  onboard city  page  and action.",
    url: "/app/configuration/city-onboard",
    path: "city-onboard",
    children: {},
  },
  CITY_SETUP_ONBOARD_EDIT: {
    id: "CITY_SETUP_ONBOARD_EDIT",
    title: "city_setup_onboard_edit",
    icon: "",
    RBACDescription: "Access to  onboard city  page  and action.",
    url: "/app/configuration/city-onboard",
    path: "city-onboard",
    children: {},
  },
  SERVICE_SETUP: {
    id: "SERVICE_SETUP",
    title: "service_setup",
    icon: "",
    url: "/app/configuration/service-setup",
    RBACDisplayName: "SERVICES LIST",
    RBACDescription: "Access to setup servies list page.",
    path: "service-setup",
    children: {},
  },
  SERVICE_SETUP_ONBOARD: {
    id: "SERVICE_SETUP_ONBOARD",
    title: "service_setup_onboard",
    icon: "",
    url: "/app/configuration/service-onboard",
    RBACDescription: "Access to setup service page and action.",
    path: "service-onboard",
    children: {},
  },
  SERVICE_SETUP_ONBOARD_EDIT: {
    id: "SERVICE_SETUP_ONBOARD_EDIT",
    title: "service_setup_onboard",
    icon: "",
    url: "/app/configuration/service-onboard",
    RBACDescription: "Access to edit service page and action.",
    isVirtual: true,
    path: "service-onboard",
    children: {},
  },
  EQUIPMENT_SETUP: {
    id: "EQUIPMENT_SETUP",
    title: "equipment_setup",
    icon: "AiOutlineUser",
    url: "/app/configuration/equipment-setup",
    RBACDisplayName: "EQUIPMENT_LIST",
    RBACDescription: "Access to Equipment List.",
    path: "equipment-setup",
    children: {},
  },
  EQUIPMENT_SETUP_ONBOARD: {
    id: "EQUIPMENT_SETUP_ONBOARD",
    title: "equipment_onboard",
    icon: "AiOutlineUser",
    url: "/app/configuration/equipment-onboard",
    RBACDisplayName: "EQUIPMENT_SETUP_ONBOARD",
    RBACDescription: "Access to equipment onboard page and action.",
    path: "equipment-onboard",
    children: {},
  },
  WAREHOUSE_LIST: {
    id: "WAREHOUSE_LIST",
    title: "equipment_setup",
    icon: "AiOutlineUser",
    url: "/app/configuration/warehouse-setup",
    // RBACDisplayName: "EQUIPMENT_LIST",
    // RBACDescription: "Access to Equipment List.",
    path: "warehouse-setup",
    children: {},
  },
  WAREHOUSE_ONBOARD: {
    id: "WAREHOUSE_ONBOARD",
    title: "equipment_onboard",
    icon: "AiOutlineUser",
    url: "/app/configuration/warehouse-onboard",
    // RBACDisplayName: "EQUIPMENT_SETUP_ONBOARD",
    // RBACDescription: "Access to equipment onboard page and action.",
    path: "warehouse-onboard",
    children: {},
  },

  EQUIPMENT_SETUP_ONBOARD_EDIT: {
    id: "EQUIPMENT_SETUP_ONBOARD_EDIT",
    title: "equipment_onboard",
    icon: "AiOutlineUser",
    url: "/app/configuration/equipment-onboard",
    RBACDescription: "Access to equipment edit onboard page and action.",
    isVirtual: true,
    path: "equipment-onboard",
    children: {},
  },
  STORE_TIMING_SETUP: {
    id: "STORE_TIMING_SETUP",
    title: "store_timing_setup",
    icon: "AiOutlineUser",
    url: "/app/configuration/store-timing-setup",
    RBACDisplayName: "STORE_TIMING_SETUP",
    RBACDescription: "Access to quick commerce store opening and closing timing setup.",
    path: "store-timing-setup",
    children: {},
  },
  PINCODE_SETUP: {
    id: "PINCODE_SETUP",
    title: "pincode_setup",
    icon: "AiOutlineUser",
    url: "/app/configuration/pincode-setup",
    RBACDescription: "Access to pincode list page",
    RBACDisplayName: "PINCODE_LIST",
    path: "pincode-setup",
    children: {},
  },
  PINCODE_ONBOARD: {
    id: "PINCODE_ONBOARD",
    title: "PINCODE_ONBOARD",
    icon: "AiOutlineUser",
    url: "/app/configuration/pincode-onboard",
    RBACDescription: "Access to pincode onboard page and action.",
    path: "pincode-onboard",
    children: {},
  },
  PINCODE_WEATHER_SETUP: {
    id: "PINCODE_WEATHER_SETUP",
    title: "pincode_weather_setup",
    icon: "AiOutlineUser",
    url: "/app/configuration/pincode-weather-setup",
    RBACDescription: "Access to pincode weather (rain) settings page",
    RBACDisplayName: "PINCODE_WEATHER_LIST",
    path: "pincode-weather-setup",
    children: {},
  },
  HOME_TILE_SETUP: {
    id: "HOME_TILE_SETUP",
    title: "home_tile_setup",
    icon: "AiOutlineUser",
    url: "/app/configuration/home-tile-setup",
    RBACDescription: "Access to the home tile ribbon configuration list page.",
    RBACDisplayName: "HOME_TILE_CONFIG_LIST",
    path: "home-tile-setup",
    children: {},
  },
  HOME_TILE_ONBOARD: {
    id: "HOME_TILE_ONBOARD",
    title: "home_tile_onboard",
    icon: "AiOutlineUser",
    url: "/app/configuration/home-tile-onboard",
    RBACDescription: "Access to create or edit a home tile ribbon configuration.",
    RBACDisplayName: "HOME_TILE_CONFIG_ONBOARD",
    path: "home-tile-onboard",
    children: {},
  },
  CLINIC_TAG_SETUP: {
    id: "CLINIC_TAG_SETUP",
    title: "clinic_tag_setup",
    icon: "AiOutlineUser",
    url: "/app/configuration/clinic-tag-setup",
    RBACDescription: "Access to the clinic tag configuration list page.",
    RBACDisplayName: "CLINIC_TAG_CONFIG_LIST",
    path: "clinic-tag-setup",
    children: {},
  },
  CLINIC_TAG_ONBOARD: {
    id: "CLINIC_TAG_ONBOARD",
    title: "clinic_tag_onboard",
    icon: "AiOutlineUser",
    url: "/app/configuration/clinic-tag-onboard",
    RBACDescription: "Access to create or edit a clinic tag configuration.",
    RBACDisplayName: "CLINIC_TAG_CONFIG_ONBOARD",
    path: "clinic-tag-onboard",
    children: {},
  },
  PINCODE_ONBOARD_EDIT: {
    id: "PINCODE_ONBOARD_EDIT",
    title: "PINCODE_ONBOARD",
    icon: "AiOutlineUser",
    RBACDescription: "Access to pincode edit page and action",
    isVirtual: true,
    url: "/app/configuration/pincode-onboard",
    path: "pincode-onboard",
    children: {},
  },
  STAFF_SETUP: {
    id: "STAFF_SETUP",
    title: "staff_setup",
    icon: "AiOutlineUser",
    RBACDisplayName: "STAFF_LIST",
    RBACDescription: "Access to staff list page or action.",
    url: "/app/configuration/staff-setup",
    path: "staff-setup",
    children: {},
  },
  STAFF_ONBOARDING: {
    id: "STAFF_ONBOARDING",
    title: "staff_onboarding",
    icon: "AiOutlineUser",
    RBACDisplayName: "STAFF_ONBOARDING",
    RBACDescription: "Access to staff onboarding list page or action.",
    url: "/app/configuration/staff-onboarding",
    path: "staff-onboarding",
    children: {},
  },
  STAFF_ONBOARDING_FORM: {
    id: "STAFF_ONBOARDING_FORM",
    title: "staff_onboarding_form",
    icon: "AiOutlineUser",
    RBACDisplayName: "STAFF_ONBOARDING_FORM",
    RBACDescription: "Access to staff onboarding form or action.",
    url: "/app/configuration/staff-onboarding-form",
    path: "staff-onboarding-form",
    children: {},
  },
  STAFF_CLINIC_MAP: {
    id: "STAFF_CLINIC_MAP",
    title: "staff_clinic_mapping",
    icon: "AiOutlineUser",
    RBACDisplayName: "STAFF_CLINIC_MAP",
    RBACDescription: "Access to staff clinic mapping page or action.",
    url: "/app/configuration/staff-clinic-mapping",
    path: "staff-clinic-mapping",
    children: {},
  },
  PARAVET_SETUP: {
    id: "PARAVET_SETUP",
    title: "paravet_setup",
    icon: "AiOutlineUser",
    RBACDisplayName: "PARAVET_LIST",
    RBACDescription: "Access to paravet list page or action.",
    url: "/app/configuration/paravet-setup",
    path: "paravet-setup",
    children: {},
  },
  PARAVET_SETUP_ONBOARD: {
    id: "PARAVET_SETUP_ONBOARD",
    title: "paravet_onboard",
    icon: "AiOutlineUser",
    RBACDisplayName: "PARAVET_ONBOARD",
    RBACDescription: "Access to paravet onboard page or action.",
    url: "/app/configuration/paravet-onboard",
    path: "paravet-onboard",
    children: {},
  },
  PARAVET_CLINIC_MAP: {
    id: "PARAVET_CLINIC_MAP",
    title: "paravet_clinic_mapping",
    icon: "AiOutlineUser",
    RBACDisplayName: "PARAVET_CLINIC_MAP",
    RBACDescription: "Access to paravet clinic mapping page or action.",
    url: "/app/configuration/paravet-clinic-mapping",
    path: "paravet-clinic-mapping",
    children: {},
  },
  PARAVET_EDIT_ACTION: {
    id: "PARAVET_EDIT_ACTION",
    title: "paravet_edit",
    icon: "PiUserListLight",
    path: "paravet-edit",
    RBACDisplayName: "PARAVET_EDIT_ACTION",
    RBACDescription: "Access to edit action in paravet list.",
    isVirtual: true,
    url: "/app/configuration/paravet-edit",
    children: {},
  },
  GROOMER_SETUP: {
    id: "GROOMER_SETUP",
    title: "groomer_setup",
    icon: "AiOutlineUser",
    RBACDisplayName: "GROOMER_LIST",
    RBACDescription: "Access to groomer list page or action.",
    url: "/app/configuration/groomer-setup",
    path: "groomer-setup",
    children: {},
  },
  GROOMER_SETUP_ONBOARD: {
    id: "GROOMER_SETUP_ONBOARD",
    title: "groomer_onboard",
    icon: "AiOutlineUser",
    RBACDisplayName: "GROOMER_ONBOARD",
    RBACDescription: "Access to groomer onboard page or action.",
    url: "/app/configuration/groomer-onboard",
    path: "groomer-onboard",
    children: {},
  },
  GROOMER_CLINIC_MAP: {
    id: "GROOMER_CLINIC_MAP",
    title: "groomer_clinic_mapping",
    icon: "AiOutlineUser",
    RBACDisplayName: "GROOMER_CLINIC_MAP",
    RBACDescription: "Access to groomer onboard page or action.",
    url: "/app/configuration/groomer-clinic-mapping",
    path: "groomer-clinic-mapping",
    children: {},
  },
  CONTRACTUAL_GROOMER: {
    id: "CONTRACTUAL_GROOMER",
    title: "contractual_groomer",
    icon: "PiUserListLight",
    path: "groomer-onboard-contractual",
    RBACDisplayName: "CONTRACTUAL_GROOMER_CTA",
    RBACDescription: "Access to action button CTA in contractual groomer.",
    isVirtual: true,
    url: "/app/configuration/groomer-onboard-contractual",
    children: {},
  },
  NON_CONTRACTUAL_GROOMER: {
    id: "NON_CONTRACTUAL_GROOMER",
    title: "non_contractual_groomer",
    icon: "PiUserListLight",
    path: "groomer-onboard-non-contractual",
    RBACDisplayName: "NON_CONTRACTUAL_GROOMER_CTA",
    RBACDescription: "Access to action button CTA in Non contractual groomer.",
    isVirtual: true,
    url: "/app/configuration/groomer-onboard-non-contractual",
    children: {},
  },
  GROOMER_EDIT_ACTION: {
    id: "GROOMER_EDIT_ACTION",
    title: "GROOMER_EDIT_ACTION",
    icon: "PiUserListLight",
    path: "groomer-onboard-non-contractual",
    RBACDisplayName: "GROOMER_EDIT_ACTION",
    RBACDescription: "Access to action button CTA in  groomer.",
    isVirtual: true,
    url: "/app/configuration/groomer-edit",
    children: {},
  },

  STAFF_SETUP_ONBOARD: {
    id: "STAFF_SETUP_ONBOARD",
    title: "staff_onboard",
    icon: "AiOutlineUser",
    url: "/app/configuration/staff-onboard",
    RBACDescription: "Access to setup staff page or action.",
    path: "staff-onboard",
    children: {},
  },
  STAFF_SETUP_ONBOARD_EDIT: {
    id: "STAFF_SETUP_ONBOARD_EDIT",
    title: "staff_onboard",
    icon: "AiOutlineUser",
    RBACDescription: "Access to edit staff page and action.",
    isVirtual: true,
    url: "/app/configuration/staff-onboard",
    path: "staff-onboard",
    children: {},
  },
  STAFF_CATEGORY_SETUP: {
    id: "STAFF_CATEGORY_SETUP",
    title: "staff_category_setup",
    icon: "AiOutlineUser",
    RBACDisplayName: "STAFF_CATEGORY_LIST",
    RBACDescription: "Access to staff category list",
    url: "/app/configuration/staff-category-setup",
    path: "staff-category-setup",
    children: {},
  },
  STAFF_CATEGORY_SETUP_ONBOARD: {
    id: "STAFF_CATEGORY_SETUP_ONBOARD",
    title: "staff_category_onboard",
    icon: "AiOutlineUser",
    RBACDescription: "Access to staff category onboard page or action",
    url: "/app/configuration/staff-category-onboard",
    path: "staff-category-onboard",
    children: {},
  },
  STAFF_CATEGORY_SETUP_ONBOARD_EDIT: {
    id: "STAFF_CATEGORY_SETUP_ONBOARD_EDIT",
    title: "staff_category_onboard",
    icon: "AiOutlineUser",
    RBACDescription: "Access to staff category onboard page or action",
    url: "/app/configuration/staff-category-onboard",
    path: "staff-category-onboard",
    isVirtual: true,
    children: {},
  },
  ROLES_PERMISSION: {
    id: "ROLES_PERMISSION",
    title: "roles_permission",
    icon: "AiOutlineUser",
    RBACDescription: "Access to roles and permission list page and action.",
    RBACDisplayName: "ROLES_AND_PERMISSION_LIST",
    url: "/app/configuration/roles-setup",
    path: "roles-setup",
    children: {},
  },
  ROLES_PERMISSION_ONBOARD: {
    id: "ROLES_PERMISSION_ONBOARD",
    title: "roles_permission_onboard",
    icon: "AiOutlineUser",
    RBACDescription: "Access to roles and permission setup page and action.",
    url: "/app/configuration/roles-onboard",
    path: "roles-onboard",
    children: {},
  },
  ROLES_PERMISSION_ONBOARD_EDIT: {
    id: "ROLES_PERMISSION_ONBOARD_EDIT",
    title: "roles_permission_onboard",
    icon: "AiOutlineUser",
    RBACDescription: "Access to Roles and Permissions edit page and action.",
    isVirtual: true,
    url: "/app/configuration/roles-onboard",
    path: "roles-onboard",
    children: {},
  },
};
export const SERVICE_DESK_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  SERVECE_DESK_RAISE_ISSUE: {
    id: "SERVECE_DESK_RAISE_ISSUE",
    title: "service_desk_issue",
    icon: "AiOutlineUser",
    RBACDisplayName: "SERVECE_DESK_RAISE_ISSUE",
    url: "/app/service-desk/raise-issue",
    path: "raise-issue",
    children: {},
  },
  SERVECE_DESK_RAISE_ISSUE_LIST: {
    id: "SERVECE_DESK_RAISE_ISSUE_LIST",
    title: "service_issue_list",
    icon: "AiOutlineUser",
    RBACDisplayName: "SERVECE_DESK_RAISE_ISSUE_LIST",
    url: "/app/service-desk/issue-list",
    path: "issue-list",
    children: {},
  },
};
export const COUPON_SERVICE_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  COUPON_SERVICE_LIST: {
    id: "COUPON_SERVICE_LIST",
    title: "coupon service",
    icon: "AiOutlineUser",
    RBACDisplayName: "COUPON_SERVICE_LIST",
    url: "/app/coupon-service/coupon-list",
    path: "coupon-list",
    children: {},
  },
  COUPON_SERVICE_CREATION: {
    id: "COUPON_SERVICE_CREATION",
    title: "service_issue_list",
    icon: "AiOutlineUser",
    RBACDisplayName: "COUPON_SERVICE_CREATION",
    url: "/app/coupon-service/coupon-creation",
    path: "coupon-creation",
    children: {},
  },
};

export const MEMBERSHIP_SETUP_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  MEMBERSHIP_SETUP_LIST: {
    id: "MEMBERSHIP_SETUP_LIST",
    title: "membership setup",
    icon: "AiOutlineUser",
    RBACDisplayName: "MEMBERSHIP_SETUP_LIST",
    url: "/app/membership-setup/membership-list",
    path: "membership-list",
    children: {},
  },
  MEMBERSHIP_SETUP_CREATION: {
    id: "MEMBERSHIP_SETUP_CREATION",
    title: "membership_creation",
    icon: "AiOutlineUser",
    RBACDisplayName: "MEMBERSHIP_SETUP_CREATION",
    url: "/app/membership-setup/membership-creation",
    path: "membership-creation",
    children: {},
  },
};

export const MEMBERSHIP_EXTENSION_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  MEMBERSHIP_EXTENSION_LIST: {
    id: "MEMBERSHIP_EXTENSION_LIST",
    title: "membership extension setup",
    icon: "AiOutlineUser",
    RBACDisplayName: "MEMBERSHIP_SETUP_LIST",
    url: "/app/membership-extension/membership-extension-list",
    path: "membership-extension-list",
    children: {},
  },
  MEMBERSHIP_EXTENSION_CREATION: {
    id: "MEMBERSHIP_EXTENSION_CREATION",
    title: "membership_extension_creation",
    icon: "AiOutlineUser",
    RBACDisplayName: "MEMBERSHIP_SETUP_CREATION",
    url: "/app/membership-extension/membership-extension-creation",
    path: "membership-extension-creation",
    children: {},
  },
};

export const VOUCHER_SETUP_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  VOUCHER_SETUP_LIST: {
    id: "VOUCHER_SETUP_LIST",
    title: "voucher list",
    icon: "AiOutlineUser",
    RBACDisplayName: "VOUCHER_SETUP_LIST",
    url: "/app/voucher-setup/voucher-list",
    path: "voucher-list",
    children: {},
  },
  VOUCHER_SETUP_CREATION: {
    id: "VOUCHER_SETUP_CREATION",
    title: "voucher creation",
    icon: "AiOutlineUser",
    RBACDisplayName: "VOUCHER_SETUP_CREATION",
    url: "/app/voucher-setup/voucher-creation",
    path: "voucher-creation",
    children: {},
  },
};

export const GIFT_SETUP_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  GIFT_SETUP_LIST: {
    id: "GIFT_SETUP_LIST",
    title: "gift list",
    icon: "AiOutlineUser",
    RBACDisplayName: "GIFT_SETUP_LIST",
    RBACDescription: "Access to the gift setup list page.",
    url: "/app/gift-setup/gift-list",
    path: "gift-list",
    children: {},
  },
  GIFT_SETUP_CREATION: {
    id: "GIFT_SETUP_CREATION",
    title: "gift creation",
    icon: "AiOutlineUser",
    RBACDisplayName: "GIFT_SETUP_CREATION",
    RBACDescription: "Access to create, edit and delete gifts.",
    url: "/app/gift-setup/gift-creation",
    path: "gift-creation",
    children: {},
  },
};

export const DATA_MAPPINGS_SUB_NAV_ROUTES: IRoutesDefined = {
  APPOINTMENT_CART_ITEM_MAPPING: {
    id: "APPOINTMENT_CART_ITEM_MAPPING",
    title: "Appointment Cart Item Mapping Details",
    description: "Access to Appointment Cart Item Mapping Details",
    path: "appointment-cart-item-mapping",
    url: "/app/mappings/appointment-cart-item-mapping",
    children: {},
  },
  APPOINTMENT_CART_ITEM_MAPPING_EDIT: {
    id: "APPOINTMENT_CART_ITEM_MAPPING_EDIT",
    title: "appointment_cart_item_mapping_edit",
    icon: "",
    RBACDescription: "Access to Appointment Cart Item Mapping and action.",
    url: "/app/mappings/appointment-cart-item-mapping-onboard",
    path: "appointment-cart-item-mapping-onboard",
    children: {},
  },
  APPOINTMENT_CART_ITEM_MAPPING_ONBOARD: {
    id: "APPOINTMENT_CART_ITEM_MAPPING_ONBOARD",
    title: "appointment_cart_item_mapping_onboard",
    icon: "",
    RBACDescription: "Access to Appointment Cart Item Mapping and action.",
    url: "/app/mappings/appointment-cart-item-mapping-onboard",
    path: "appointment-cart-item-mapping-onboard",
    children: {},
  },
};

export const TILES_PAGE_SUB_NAV_ROUTES: IRoutesDefined = {
  TILES_CONFIGURATION: {
    id: "TILES_CONFIGURATION",
    title: "Tiles Details",
    description: "Access to Tiles Details",
    path: "tiles-configuration",
    url: "/app/tiles/tiles-configuration",
    children: {},
  },
};

export const WHITELIST_MOBILE_SUB_NAV_ROUTES: IRoutesDefined = {
  WHITELIST_MOBILE_ONBOARD: {
    id: "WHITELIST_MOBILE_ONBOARD",
    title: "Whitelist Mobile",
    description: "Access to whitelist mobile.",
    path: "onboard",
    url: "/app/whitelist-mobile/onboard",
    children: {},
  },
  IMAGE_GENERATION: {
    id: "IMAGE_GENERATION",
    title: "Whitelist Mobile",
    description: "Access to whitelist mobile.",
    path: "image-generation",
    url: "/app/whitelist-mobile/image-generation",
    children: {},
  },
  SLUG_MANAGEMENT: {
    id: "SLUG_MANAGEMENT",
    title: "Slug Management",
    description: "Access to slug management.",
    path: "slug-management",
    url: "/app/whitelist-mobile/slug-management",
    children: {},
  },
};
